// import { RecaptchaV3 } from 'js-pimcore-formbuilder';

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('form.formbuilder').forEach((form) => {
//       const recap = new RecaptchaV3(form, {
//           disableFormWhileLoading: true,
//           reCaptchaFieldClass: 'input.re-captcha-v3',
//       });
//   });
// });



// import "jquery-pimcore-formbuilder/dist/jquery.fb.core";
// import "jquery-pimcore-formbuilder/dist/jquery.fb.ext.recaptcha-v3";
// document.addEventListener('DOMContentLoaded', () => {
//     $('form.formbuilder').formBuilderReCaptchaV3({
//         disableFormWhileLoading: true
//     });
// });

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form.formbuilder').forEach((form) => {
    const reCaptchaField = form.querySelector('input.re-captcha-v3');
    if (reCaptchaField) {
      const siteKey = reCaptchaField.dataset.siteKey;
      const actionName = reCaptchaField.dataset.actionName || 'submit';

      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);

      script.onload = () => {
        function getRecaptchaToken(submitBtn = null){
          grecaptcha.execute(siteKey, { action: actionName }).then(function(token){
            reCaptchaField.value = token;
            if(submitBtn){
              submitBtn.click();
            }
          });
        };

        grecaptcha.ready(function() {
          getRecaptchaToken();
        });


        var submitbtn = form.querySelector('button[type="submit"]');
        var clonebtn = submitbtn.cloneNode(true);
        clonebtn.name='';
        submitbtn.classList.add('d-none');
        submitbtn.parentElement.appendChild(clonebtn);
        
        clonebtn.addEventListener('click', function(event){
          event.preventDefault(); 
          getRecaptchaToken(submitbtn);
        });
        

        /** Add disable and class */
        let observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === "attributes" && mutation.attributeName === "disabled") {
              if (mutation.target.hasAttribute("disabled")) {
                clonebtn.setAttribute("disabled", "disabled");
              } else {
                clonebtn.removeAttribute("disabled");
              }
            }
          });
        });

        observer.observe(submitbtn, { attributes: true });


      };
    }
  });
});

